import React from "react";
import type { TBuilderToolbarMenuViewPresentation } from "components/builderShell/BuilderToolbarMenuView";
import { BuilderToolbarMenuView } from "components/builderShell/BuilderToolbarMenuView";
import type { IBuilderToolbarMenuViewSection } from "components/builderShell/types";
import { useTranslation } from "react-i18next";
import { EmailBuilderBlockPalette } from "./EmailBuilderBlockPalette";
import { EmailBuilderColumnPalette } from "./EmailBuilderColumnPalette";
import { EmailBuilderSectionPalette } from "./EmailBuilderSectionPalette";
import "components/builderShell/builderToolbarMenuView.scss";
import "./emailBuilderAddElementsPanel.scss";

interface IEmailBuilderAddElementsToolbarMenuProps {
  presentation?: TBuilderToolbarMenuViewPresentation;
  onClose?: () => void;
  closeAriaLabel?: string;
  onAfterInsert?: () => void;
}

function useEmailBuilderAddElementsPanelModel(onAfterInsert?: () => void) {
  const { t } = useTranslation();
  function completeInsert() {
    onAfterInsert?.();
  }

  const toolbarSections: IBuilderToolbarMenuViewSection[] = [
    {
      title: t("Base"),
      content: <EmailBuilderBlockPalette onAfterInsert={completeInsert} />,
    },
    {
      title: t("Columns"),
      content: <EmailBuilderColumnPalette onAfterInsert={completeInsert} />,
    },
    {
      title: t("Sections"),
      content: <EmailBuilderSectionPalette onAfterInsert={completeInsert} />,
    },
  ];

  return {
    t,
    toolbarSections,
  };
}

export function EmailBuilderAddElementsToolbarMenu(props: IEmailBuilderAddElementsToolbarMenuProps) {
  const { t, toolbarSections } = useEmailBuilderAddElementsPanelModel(props.onAfterInsert);
  const presentation = props.presentation ?? "desktop-panel";

  return (
    <BuilderToolbarMenuView
      title={t("Add elements")}
      presentation={presentation}
      onClose={props.onClose}
      closeAriaLabel={props.closeAriaLabel}
      sections={toolbarSections}
    />
  );
}
